import {
    Directive,
    ElementRef,
    Renderer,
    Input,
    OnInit,
    EventEmitter,
    Output,
    SimpleChanges,
    AfterViewInit,
    OnChanges,
    ViewChild
} from '@angular/core';

import { AppConstants } from '../shared/constants/constants';
import { Utility } from '../common/utility';
import { VaccinationService } from '../pages/consultation-history/vaccination/vaccination.service';
import { FormControl } from '@angular/forms';
import { ValidationService } from '../shared/services/validation.service';
import * as moment from 'moment';
declare var $j: any;

@Directive({
    selector: `[tmbdatetimepicker]`
})
export class DateTimePickerDirective implements OnInit, AfterViewInit, OnChanges {

    @Input() options;
    @Input() min = null;
    @Input() max = null;
    @Input() disabled = false;
    @Input() value = null;
    @Input() formControl: FormControl;
    @Input() birthDay = false;
    @Output() dateChange = new EventEmitter<any>();
    @Output() dateInput = new EventEmitter<any>();
    @ViewChild('datePicker') datePicker: ElementRef;
    private el;
   // private dpElement;
    private dpOption = {
        changeMonth: true,
        changeYear: true,
        maxDate: this.max,
        minDate: this.min,
        dateFormat: 'd M yy', //AppConstants.dateConfig.date
        showOn: 'both',
        buttonImage: 'assets/images/icons/date-picker.svg',
        buttonImageOnly: true,
        buttonText: 'Select date'
    };

    constructor(el: ElementRef, renderer: Renderer, private utility: Utility) {
        this.el = el;
       // const $parent = $j(el.nativeElement.parentNode);
       // this.dpElement = $parent.hasClass('input-group') ? $parent : $j(el.nativeElement);

    }
    ngOnInit() {
        if (this.formControl) {
            this.formControl.valueChanges.subscribe((value) => {
                if (Object.prototype.toString.call(value) === '[object Date]') {
                    this.updateElement(value);
                }
            });
        }

       // add this code temporary to prevent click on a link on datepicker system redirect to /#
        $j('body').on('click', 'a', function (event) {
            const target = event.target;
            if (target.attributes['href'] && target.attributes['href'].nodeValue === '#') {
                event.preventDefault();
            }
        });
    }

    ngOnChanges(changes: SimpleChanges) {
      if (changes.hasOwnProperty('disabled')) {
        this.changeDisable(changes.disabled.currentValue);
      }
    }

    changeDisable(isDisable) {
        if (isDisable === true) {
            $j(this.el.nativeElement).datepicker('disable');
        } else {
            $j(this.el.nativeElement).datepicker('enable');
        }
    }

    ngAfterViewInit(): void {
        const component = this;
        const format = (this.options) ? this.options : this.dpOption;
        let date;
        if (this.min) {
            format.minDate = this.min;
        }
        if (this.max) {
            format.maxDate = this.max;
        }
        if (this.birthDay === true) {
            format['yearRange'] = ((new Date()).getFullYear() - 100).toString() + ':' + (new Date()).getFullYear();
        }
        else
        {
            format['yearRange'] = "c-10:c+10";
        }
        if (this.formControl && this.formControl.value) {
            date = moment(this.formControl.value).format(AppConstants.dateConfig.date);
        } else if (this.value) {
            date = this.value;
        }
        $j.datepicker.setDefaults( format );
        $j(this.el.nativeElement).datepicker({
            onSelect: function(dateText: string) {
                component.doEmitDate(dateText);
            }
        }).datepicker('setDate', date);
        if (this.disabled === true) {
            $j(this.el.nativeElement).datepicker('disable');
        }

        $j(this.el.nativeElement).on('change', (e) => {
            component.doEmitDate(e.target.value, true);
        });
    }

    doEmitDate(dateText: string, isDateInputChange = false) {
        let date = new Date(dateText);
        if (Object.prototype.toString.call(date) !== '[object Date]' || isNaN(date.getTime())) {
            date = null;
            if ( this.formControl) {
                this.formControl.setErrors({ 'invalidDate': true });
            }
        }
        if ( this.formControl) {
            this.formControl.setValue(date);
        }
        this.updateElement(date);
        if (isDateInputChange) {
            this.dateInput.emit(date);
        } else {
            this.dateChange.emit(date);
        }
    }

    updateElement(value) {
        if (value) {
            this.el.nativeElement.value = moment(value).format(AppConstants.dateConfig.date);
        }
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/directives/datepicker.directive.ts